import { render, staticRenderFns } from "./AdminFinalExamSettingsExaminersView.vue?vue&type=template&id=ff0720d2"
import script from "./AdminFinalExamSettingsExaminersView.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamSettingsExaminersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports